import FolderPagedContentContainer from './FolderPagedContent.container';
import FolderPagedContent from './FolderPagedContent';

export default FolderPagedContentContainer(FolderPagedContent);
